<template>
  <credit-widget
    class="expenditure-insights"
    data-testid="expenditure-insights-widget"
  >
    <template #widget-header>
      <i-icon
        class="icon i-text-neutral-110"
        symbol="small-money-cash-coins-stack"
        :size="16"
      ></i-icon>
      <span>Expenditure Insights</span>
    </template>
    <template #widget-content>
      <div class="line large">
        <span>Total Expenditure</span>
        <credit-widget-value
          :value="totalExpenditure"
          :currency="true"
        ></credit-widget-value>
      </div>
      <div
        v-for="(categoryNum, categoryIndex) in displayNumber"
        :key="`category-${categoryIndex}`"
        class="line"
      >
        <span v-if="categoryIndex < spendingCategory.length">{{
          spendingCategory[categoryIndex].name
        }}</span>
        <span v-else>Top Spending Category {{ categoryNum }}</span>
        <credit-widget-value
          :value="
            categoryIndex < spendingCategory.length
              ? spendingCategory[categoryIndex].total
              : null
          "
          :currency="true"
        ></credit-widget-value>
      </div>
      <div class="divider"></div>
      <div
        v-for="(merchantNum, merchantIndex) in displayNumber"
        :key="`merchant-${merchantIndex}`"
        class="line"
      >
        <span v-if="merchantIndex < spendingMerchant.length">{{
          spendingMerchant[merchantIndex].name
        }}</span>
        <span v-else>Top Spending Merchant {{ merchantNum }}</span>
        <credit-widget-value
          :value="
            merchantIndex < spendingMerchant.length
              ? spendingMerchant[merchantIndex].total
              : null
          "
          :currency="true"
        ></credit-widget-value>
      </div>
    </template>
  </credit-widget>
</template>

<script>
import { mapState } from 'vuex';
import CreditWidget from '@/V2/credit/widgets/CreditWidget';
import CreditWidgetValue from '@/V2/credit/widgets/CreditWidgetValue';
import { iIcon } from '@inscribe/signal';
import { normalizeText } from '@/V2/credit/granular-insights/components/components.utils';

export default {
  name: 'ExpenditureInsights',
  components: { CreditWidget, CreditWidgetValue, iIcon },
  data() {
    return {
      displayNumber: 3,
    };
  },
  computed: {
    ...mapState({
      credit: 'credit',
    }),
    totalExpenditure() {
      return this.credit?.customerExpenditure?.total_spend;
    },
    spendingCategory() {
      return this.sortOutput(
        this.credit?.customerExpenditure?.spend_by_category,
      );
    },
    spendingMerchant() {
      return this.sortOutput(
        this.credit?.customerExpenditure?.spend_by_vendor,
        false,
      );
    },
  },
  methods: {
    sortOutput(spendData, normalize = true) {
      if (!spendData) {
        return [];
      }
      const array = [];
      Object.keys(spendData).forEach((key) => {
        const total = spendData[key].total;
        if (total > 0) {
          array.push({
            name: normalize ? normalizeText(key) : key,
            total: spendData[key].total,
          });
        }
      });
      array.sort((a, b) => (a.total > b.total ? -1 : 1));
      return array;
    },
  },
};
</script>
